/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdministeredDrug,
  AppointmentNote,
  AppointmentNoteDraft,
  AppointmentNoteStamp,
  CPP,
  CPPAndChatUnreadCount,
  Consultant,
  CreateReportDocumentPayload,
  ErrorResponse,
  HealthData,
  HealthRecords,
  HealthRecordsInformation,
  HealthRecordsMetricAggregated,
  HealthRecordsMetricSummary,
  HistoryIssue,
  Immunization,
  ImmunizationDescription,
  InternPendingRecords,
  LifestyleFactor,
  MTDate,
  MTReminderDescription,
  MTTutorialData,
  MTUpdate,
  MedicalOrder,
  MedicationReminder,
  MedicationReminderNotification,
  MedicationReminderTake,
  MetricType,
  MetricValue,
  MultipleValuesPayload,
  Patient,
  PatientDocument,
  PatientIssue,
  PatientMedication,
  Prescription,
  PrescriptionRefill,
  Referral,
  ReferralRequest,
  Resource,
  VitalityDrugDescription,
} from '../models';
import {
    AdministeredDrugFromJSON,
    AdministeredDrugToJSON,
    AppointmentNoteFromJSON,
    AppointmentNoteToJSON,
    AppointmentNoteDraftFromJSON,
    AppointmentNoteDraftToJSON,
    AppointmentNoteStampFromJSON,
    AppointmentNoteStampToJSON,
    CPPFromJSON,
    CPPToJSON,
    CPPAndChatUnreadCountFromJSON,
    CPPAndChatUnreadCountToJSON,
    ConsultantFromJSON,
    ConsultantToJSON,
    CreateReportDocumentPayloadFromJSON,
    CreateReportDocumentPayloadToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    HealthDataFromJSON,
    HealthDataToJSON,
    HealthRecordsFromJSON,
    HealthRecordsToJSON,
    HealthRecordsInformationFromJSON,
    HealthRecordsInformationToJSON,
    HealthRecordsMetricAggregatedFromJSON,
    HealthRecordsMetricAggregatedToJSON,
    HealthRecordsMetricSummaryFromJSON,
    HealthRecordsMetricSummaryToJSON,
    HistoryIssueFromJSON,
    HistoryIssueToJSON,
    ImmunizationFromJSON,
    ImmunizationToJSON,
    ImmunizationDescriptionFromJSON,
    ImmunizationDescriptionToJSON,
    InternPendingRecordsFromJSON,
    InternPendingRecordsToJSON,
    LifestyleFactorFromJSON,
    LifestyleFactorToJSON,
    MTDateFromJSON,
    MTDateToJSON,
    MTReminderDescriptionFromJSON,
    MTReminderDescriptionToJSON,
    MTTutorialDataFromJSON,
    MTTutorialDataToJSON,
    MTUpdateFromJSON,
    MTUpdateToJSON,
    MedicalOrderFromJSON,
    MedicalOrderToJSON,
    MedicationReminderFromJSON,
    MedicationReminderToJSON,
    MedicationReminderNotificationFromJSON,
    MedicationReminderNotificationToJSON,
    MedicationReminderTakeFromJSON,
    MedicationReminderTakeToJSON,
    MetricTypeFromJSON,
    MetricTypeToJSON,
    MetricValueFromJSON,
    MetricValueToJSON,
    MultipleValuesPayloadFromJSON,
    MultipleValuesPayloadToJSON,
    PatientFromJSON,
    PatientToJSON,
    PatientDocumentFromJSON,
    PatientDocumentToJSON,
    PatientIssueFromJSON,
    PatientIssueToJSON,
    PatientMedicationFromJSON,
    PatientMedicationToJSON,
    PrescriptionFromJSON,
    PrescriptionToJSON,
    PrescriptionRefillFromJSON,
    PrescriptionRefillToJSON,
    ReferralFromJSON,
    ReferralToJSON,
    ReferralRequestFromJSON,
    ReferralRequestToJSON,
    ResourceFromJSON,
    ResourceToJSON,
    VitalityDrugDescriptionFromJSON,
    VitalityDrugDescriptionToJSON,
} from '../models';

export interface AddAdministeredDrugRequest {
    administeredDrug: AdministeredDrug;
    chargeAmount?: string;
}

export interface AddHealthDataRequest {
    patientId: string;
    healthData: HealthData;
    allowOverlap?: boolean;
}

export interface AddImmunizationRequest {
    immunization: Immunization;
    chargeAmount?: string;
}

export interface AddMedicationReminderRequest {
    medicationReminder: MedicationReminder;
}

export interface AddNotesAttachmentRequest {
    patientId: string;
    file: Blob;
    notes?: string;
    hide?: boolean;
}

export interface AddNotesDraftRequest {
    appointmentNoteDraft: AppointmentNoteDraft;
}

export interface AddNotesTextRequest {
    appointmentNote: AppointmentNote;
}

export interface AddOrEditAppointmentNoteStampRequest {
    appointmentNoteStamp: AppointmentNoteStamp;
}

export interface AddOrEditHealthRecordConsultantRequest {
    patientId: string;
    consultants: Array<Consultant>;
}

export interface AddOrEditHealthRecordHistoryIssueRequest {
    patientId: string;
    historyIssues: Array<HistoryIssue>;
}

export interface AddOrEditHealthRecordLifestyleFactorRequest {
    patientId: string;
    lifestyleFactors: Array<LifestyleFactor>;
}

export interface AddOrEditHealthRecordPatientIssueRequest {
    patientId: string;
    field: AddOrEditHealthRecordPatientIssueFieldEnum;
    patientIssues: Array<PatientIssue>;
}

export interface AddOrEditHealthRecordPatientMedicationRequest {
    patientId: string;
    patientMedications: Array<PatientMedication>;
}

export interface AddOrEditMedicalOrderRequest {
    patientId: string;
    medicalOrder: MedicalOrder;
}

export interface AddPrescriptionRequest {
    prescription: Prescription;
    fax?: boolean;
}

export interface AddPrescriptionRefillRequest {
    prescriptionRefill: PrescriptionRefill;
}

export interface AddReferralRequest {
    referral: Referral;
    fax?: boolean;
    email?: boolean;
}

export interface AddReferralAsInternRequest {
    referral: Referral;
}

export interface AddReferralRequestRequest {
    referralRequest: ReferralRequest;
}

export interface CountUnreadHealthRecordsRequest {
    patientId: string;
}

export interface CreateReportDocumentRequest {
    createReportDocumentPayload: CreateReportDocumentPayload;
}

export interface DeleteAppointmentNoteStampRequest {
    id: string;
}

export interface DeleteHealthRecordConsultantRequest {
    patientId: string;
    consultantId: string;
}

export interface DeleteHealthRecordHistoryIssueRequest {
    patientId: string;
    issueId: string;
}

export interface DeleteHealthRecordLifestyleFactorRequest {
    patientId: string;
    factorId: string;
}

export interface DeleteHealthRecordMedicationRequest {
    patientId: string;
    medicationId: string;
}

export interface DeleteHealthRecordPatientIssueRequest {
    patientId: string;
    field: DeleteHealthRecordPatientIssueFieldEnum;
    issueId: string;
}

export interface DeleteMedicalOrderRequest {
    patientId: string;
    date: number;
}

export interface DeleteNoteRequest {
    id: string;
}

export interface DeleteNotesDraftRequest {
    patientId: string;
    id: string;
}

export interface DeleteReferralRequest {
    patientId: string;
    id: string;
}

export interface DiscontinueMedicationReminderRequest {
    id: string;
}

export interface EditNoteRequest {
    id: string;
    appointmentNote: AppointmentNote;
}

export interface EditPrescriptionRefillRequest {
    id: string;
    patientId: string;
    prescriptionRefill: PrescriptionRefill;
}

export interface ExportAdministeredDrugsRequest {
    patientId: string;
}

export interface ExportCPPRequest {
    patientId: string;
    from?: number;
    to?: number;
    excludeNotes?: boolean;
    excludeDocuments?: boolean;
    excludeSummary?: boolean;
}

export interface ExportImmunizationsRequest {
    patientId: string;
}

export interface GenerateImmunizationsRequest {
    patientId: string;
}

export interface GetAppointmentNoteStampRequest {
    id: string;
}

export interface GetCPPRequest {
    patientId: string;
}

export interface GetHealthDataSummaryRequest {
    patientId: string;
}

export interface GetHealthRecordsRequest {
    patientId: string;
}

export interface GetLatestMetricValueRequest {
    patientId: string;
    metric: string;
    origin?: GetLatestMetricValueOriginEnum;
}

export interface GetMedicationReminderNotificationsRequest {
    patientId: string;
    from: number;
    to: number;
    includeDiscontinued?: boolean;
}

export interface GetMedicationRemindersRequest {
    patientId: string;
}

export interface GetMenstruationDataRequest {
    id: string;
}

export interface GetNotesAttachmentRequest {
    appointmentNoteId: string;
}

export interface GetPatientNotesDraftRequest {
    patientId: string;
    backups?: boolean;
}

export interface GetPrescriptionAttachmentRequest {
    patientId: string;
    prescriptionId: string;
    resource: Resource;
}

export interface GetPrescriptionPDFRequest {
    patientId: string;
    prescriptionId: string;
}

export interface GetPrescriptionRefillsRequest {
    clinicId?: string;
}

export interface GetReferralsByStatusRequest {
    status: GetReferralsByStatusStatusEnum;
}

export interface GetSpecificHealthDataRequest {
    patientId: string;
    metric: string;
    type?: string;
    origin?: string;
}

export interface MarkAllHealthRecordsReadRequest {
    patientId: string;
}

export interface MarkHealthRecordReadRequest {
    patientId: string;
    type: MarkHealthRecordReadTypeEnum;
    id: string;
}

export interface PreviewPrescriptionRequest {
    prescription: Prescription;
}

export interface PreviewReferralRequest {
    referral: Referral;
}

export interface RemoveAdministeredDrugRequest {
    id: string;
    patientId: string;
}

export interface RemoveImmunizationRequest {
    id: string;
    patientId: string;
}

export interface RemovePrescriptionRequest {
    id: string;
}

export interface RemovePrescriptionRefillRequest {
    id: string;
    patientId: string;
}

export interface RemoveReferralRequestRequest {
    id: string;
}

export interface ResetMenstruationDataRequest {
    id: string;
}

export interface SearchHealthRecordsRequest {
    term: string;
    physicianId: string;
    multipleValuesPayload: MultipleValuesPayload;
}

export interface SnoozeMedicationReminderRequest {
    duration: number;
    medicationReminderNotification: MedicationReminderNotification;
}

export interface UpdateHealthRecordsInformationRequest {
    patientId: string;
    healthRecordsInformation: HealthRecordsInformation;
}

export interface UpdateMedicationReminderRequest {
    medicationReminder: MedicationReminder;
}

export interface UpdateMedicationReminderTakeRequest {
    id: string;
    medicationReminderTake: MedicationReminderTake;
}

export interface UpdateMenstruationDatesRequest {
    id: string;
    mTDates: Array<MTDate>;
}

export interface UpdateMenstruationTutorialDataRequest {
    id: string;
    mTTutorialData: MTTutorialData;
}

export interface UpdatePrescriptionRequest {
    patientId: string;
    prescriptionId: string;
    prescription: Prescription;
}

export interface UpdateReferralRequest {
    patientId: string;
    id: string;
    patientDocument: PatientDocument;
}

/**
 * 
 */
export class HealthRecordsApi extends runtime.BaseAPI {

    /**
     * Adds a new Administered Drug health record (Roles: physician, admin)
     */
    async addAdministeredDrugRaw(requestParameters: AddAdministeredDrugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdministeredDrug>> {
        if (requestParameters.administeredDrug === null || requestParameters.administeredDrug === undefined) {
            throw new runtime.RequiredError('AdministeredDrug','Required parameter requestParameters.administeredDrug was null or undefined when calling addAdministeredDrug.');
        }

        const queryParameters: any = {};

        if (requestParameters.chargeAmount !== undefined) {
            queryParameters['chargeAmount'] = requestParameters.chargeAmount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/administered-drugs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdministeredDrugToJSON(requestParameters.administeredDrug),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdministeredDrugFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addAdministeredDrugRequestOptionsRaw(requestParameters: AddAdministeredDrugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.administeredDrug === null || requestParameters.administeredDrug === undefined) {
            throw new runtime.RequiredError('AdministeredDrug','Required parameter requestParameters.administeredDrug was null or undefined when calling addAdministeredDrug.');
        }

        const queryParameters: any = {};

        if (requestParameters.chargeAmount !== undefined) {
            queryParameters['chargeAmount'] = requestParameters.chargeAmount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/administered-drugs`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: AdministeredDrugToJSON(requestParameters.administeredDrug),
        };
        return responseConfig
    }

    /**
     * Adds a new Administered Drug health record (Roles: physician, admin)
     */
    async addAdministeredDrug(requestParameters: AddAdministeredDrugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdministeredDrug> {
        const response = await this.addAdministeredDrugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds HealthData (Roles: patient, physician, admin)
     */
    async addHealthDataRaw(requestParameters: AddHealthDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecordsMetricAggregated>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addHealthData.');
        }

        if (requestParameters.healthData === null || requestParameters.healthData === undefined) {
            throw new runtime.RequiredError('HealthData','Required parameter requestParameters.healthData was null or undefined when calling addHealthData.');
        }

        const queryParameters: any = {};

        if (requestParameters.patientId !== undefined) {
            queryParameters['patientId'] = requestParameters.patientId;
        }

        if (requestParameters.allowOverlap !== undefined) {
            queryParameters['allowOverlap'] = requestParameters.allowOverlap;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/health-data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HealthDataToJSON(requestParameters.healthData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsMetricAggregatedFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addHealthDataRequestOptionsRaw(requestParameters: AddHealthDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addHealthData.');
        }

        if (requestParameters.healthData === null || requestParameters.healthData === undefined) {
            throw new runtime.RequiredError('HealthData','Required parameter requestParameters.healthData was null or undefined when calling addHealthData.');
        }

        const queryParameters: any = {};

        if (requestParameters.patientId !== undefined) {
            queryParameters['patientId'] = requestParameters.patientId;
        }

        if (requestParameters.allowOverlap !== undefined) {
            queryParameters['allowOverlap'] = requestParameters.allowOverlap;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/health-data`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: HealthDataToJSON(requestParameters.healthData),
        };
        return responseConfig
    }

    /**
     * Adds HealthData (Roles: patient, physician, admin)
     */
    async addHealthData(requestParameters: AddHealthDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecordsMetricAggregated> {
        const response = await this.addHealthDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new Immunization health record (Roles: physician, admin)
     */
    async addImmunizationRaw(requestParameters: AddImmunizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Immunization>> {
        if (requestParameters.immunization === null || requestParameters.immunization === undefined) {
            throw new runtime.RequiredError('Immunization','Required parameter requestParameters.immunization was null or undefined when calling addImmunization.');
        }

        const queryParameters: any = {};

        if (requestParameters.chargeAmount !== undefined) {
            queryParameters['chargeAmount'] = requestParameters.chargeAmount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/immunizations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImmunizationToJSON(requestParameters.immunization),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImmunizationFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addImmunizationRequestOptionsRaw(requestParameters: AddImmunizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.immunization === null || requestParameters.immunization === undefined) {
            throw new runtime.RequiredError('Immunization','Required parameter requestParameters.immunization was null or undefined when calling addImmunization.');
        }

        const queryParameters: any = {};

        if (requestParameters.chargeAmount !== undefined) {
            queryParameters['chargeAmount'] = requestParameters.chargeAmount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/immunizations`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ImmunizationToJSON(requestParameters.immunization),
        };
        return responseConfig
    }

    /**
     * Adds a new Immunization health record (Roles: physician, admin)
     */
    async addImmunization(requestParameters: AddImmunizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Immunization> {
        const response = await this.addImmunizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a medication reminder (Roles: patient)
     */
    async addMedicationReminderRaw(requestParameters: AddMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicationReminder>> {
        if (requestParameters.medicationReminder === null || requestParameters.medicationReminder === undefined) {
            throw new runtime.RequiredError('MedicationReminder','Required parameter requestParameters.medicationReminder was null or undefined when calling addMedicationReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/medication-reminder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MedicationReminderToJSON(requestParameters.medicationReminder),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicationReminderFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addMedicationReminderRequestOptionsRaw(requestParameters: AddMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.medicationReminder === null || requestParameters.medicationReminder === undefined) {
            throw new runtime.RequiredError('MedicationReminder','Required parameter requestParameters.medicationReminder was null or undefined when calling addMedicationReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/medication-reminder`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: MedicationReminderToJSON(requestParameters.medicationReminder),
        };
        return responseConfig
    }

    /**
     * Adds a medication reminder (Roles: patient)
     */
    async addMedicationReminder(requestParameters: AddMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicationReminder> {
        const response = await this.addMedicationReminderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds an appointment note attachment (Roles: physician)
     */
    async addNotesAttachmentRaw(requestParameters: AddNotesAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentNote>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addNotesAttachment.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling addNotesAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        if (requestParameters.notes !== undefined) {
            formParams.append('notes', requestParameters.notes as any);
        }

        if (requestParameters.hide !== undefined) {
            formParams.append('hide', requestParameters.hide as any);
        }

        const response = await this.request({
            path: `/health-records/{patientId}/notes/attachment`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentNoteFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addNotesAttachmentRequestOptionsRaw(requestParameters: AddNotesAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addNotesAttachment.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling addNotesAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        if (requestParameters.notes !== undefined) {
            formParams.append('notes', requestParameters.notes as any);
        }

        if (requestParameters.hide !== undefined) {
            formParams.append('hide', requestParameters.hide as any);
        }


        const responseConfig = {
            path: `/health-records/{patientId}/notes/attachment`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
        return responseConfig
    }

    /**
     * Adds an appointment note attachment (Roles: physician)
     */
    async addNotesAttachment(requestParameters: AddNotesAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentNote> {
        const response = await this.addNotesAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds an appointment note draft (Roles: physician)
     */
    async addNotesDraftRaw(requestParameters: AddNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentNoteDraft>> {
        if (requestParameters.appointmentNoteDraft === null || requestParameters.appointmentNoteDraft === undefined) {
            throw new runtime.RequiredError('AppointmentNoteDraft','Required parameter requestParameters.appointmentNoteDraft was null or undefined when calling addNotesDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentNoteDraftToJSON(requestParameters.appointmentNoteDraft),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentNoteDraftFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addNotesDraftRequestOptionsRaw(requestParameters: AddNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.appointmentNoteDraft === null || requestParameters.appointmentNoteDraft === undefined) {
            throw new runtime.RequiredError('AppointmentNoteDraft','Required parameter requestParameters.appointmentNoteDraft was null or undefined when calling addNotesDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/draft`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentNoteDraftToJSON(requestParameters.appointmentNoteDraft),
        };
        return responseConfig
    }

    /**
     * Adds an appointment note draft (Roles: physician)
     */
    async addNotesDraft(requestParameters: AddNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentNoteDraft> {
        const response = await this.addNotesDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds an appointment note text (Roles: physician)
     */
    async addNotesTextRaw(requestParameters: AddNotesTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentNote>> {
        if (requestParameters.appointmentNote === null || requestParameters.appointmentNote === undefined) {
            throw new runtime.RequiredError('AppointmentNote','Required parameter requestParameters.appointmentNote was null or undefined when calling addNotesText.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/text`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentNoteToJSON(requestParameters.appointmentNote),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentNoteFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addNotesTextRequestOptionsRaw(requestParameters: AddNotesTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.appointmentNote === null || requestParameters.appointmentNote === undefined) {
            throw new runtime.RequiredError('AppointmentNote','Required parameter requestParameters.appointmentNote was null or undefined when calling addNotesText.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/text`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentNoteToJSON(requestParameters.appointmentNote),
        };
        return responseConfig
    }

    /**
     * Adds an appointment note text (Roles: physician)
     */
    async addNotesText(requestParameters: AddNotesTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentNote> {
        const response = await this.addNotesTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds or edits an appointment note stamp
     */
    async addOrEditAppointmentNoteStampRaw(requestParameters: AddOrEditAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentNoteStamp>> {
        if (requestParameters.appointmentNoteStamp === null || requestParameters.appointmentNoteStamp === undefined) {
            throw new runtime.RequiredError('AppointmentNoteStamp','Required parameter requestParameters.appointmentNoteStamp was null or undefined when calling addOrEditAppointmentNoteStamp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/stamp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentNoteStampToJSON(requestParameters.appointmentNoteStamp),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentNoteStampFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addOrEditAppointmentNoteStampRequestOptionsRaw(requestParameters: AddOrEditAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.appointmentNoteStamp === null || requestParameters.appointmentNoteStamp === undefined) {
            throw new runtime.RequiredError('AppointmentNoteStamp','Required parameter requestParameters.appointmentNoteStamp was null or undefined when calling addOrEditAppointmentNoteStamp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/stamp`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentNoteStampToJSON(requestParameters.appointmentNoteStamp),
        };
        return responseConfig
    }

    /**
     * Adds or edits an appointment note stamp
     */
    async addOrEditAppointmentNoteStamp(requestParameters: AddOrEditAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentNoteStamp> {
        const response = await this.addOrEditAppointmentNoteStampRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates or adds a new Consultant in a particular Health Records element  (Roles: physician, admin)
     */
    async addOrEditHealthRecordConsultantRaw(requestParameters: AddOrEditHealthRecordConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordConsultant.');
        }

        if (requestParameters.consultants === null || requestParameters.consultants === undefined) {
            throw new runtime.RequiredError('Consultant','Required parameter requestParameters.consultants was null or undefined when calling addOrEditHealthRecordConsultant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/consultant`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.consultants.map(ConsultantToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addOrEditHealthRecordConsultantRequestOptionsRaw(requestParameters: AddOrEditHealthRecordConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordConsultant.');
        }

        if (requestParameters.consultants === null || requestParameters.consultants === undefined) {
            throw new runtime.RequiredError('Consultant','Required parameter requestParameters.consultants was null or undefined when calling addOrEditHealthRecordConsultant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/consultant`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.consultants.map(ConsultantToJSON),
        };
        return responseConfig
    }

    /**
     * Updates or adds a new Consultant in a particular Health Records element  (Roles: physician, admin)
     */
    async addOrEditHealthRecordConsultant(requestParameters: AddOrEditHealthRecordConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.addOrEditHealthRecordConsultantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates or adds a new History Issue in a particular Health Records  element (Roles: physician, admin)
     */
    async addOrEditHealthRecordHistoryIssueRaw(requestParameters: AddOrEditHealthRecordHistoryIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordHistoryIssue.');
        }

        if (requestParameters.historyIssues === null || requestParameters.historyIssues === undefined) {
            throw new runtime.RequiredError('HistoryIssue','Required parameter requestParameters.historyIssues was null or undefined when calling addOrEditHealthRecordHistoryIssue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/history-issue`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.historyIssues.map(HistoryIssueToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addOrEditHealthRecordHistoryIssueRequestOptionsRaw(requestParameters: AddOrEditHealthRecordHistoryIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordHistoryIssue.');
        }

        if (requestParameters.historyIssues === null || requestParameters.historyIssues === undefined) {
            throw new runtime.RequiredError('HistoryIssue','Required parameter requestParameters.historyIssues was null or undefined when calling addOrEditHealthRecordHistoryIssue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/history-issue`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.historyIssues.map(HistoryIssueToJSON),
        };
        return responseConfig
    }

    /**
     * Updates or adds a new History Issue in a particular Health Records  element (Roles: physician, admin)
     */
    async addOrEditHealthRecordHistoryIssue(requestParameters: AddOrEditHealthRecordHistoryIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.addOrEditHealthRecordHistoryIssueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates or adds a new Lifestyle Factor in a particular Health Records  element (Roles: physician, admin)
     */
    async addOrEditHealthRecordLifestyleFactorRaw(requestParameters: AddOrEditHealthRecordLifestyleFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordLifestyleFactor.');
        }

        if (requestParameters.lifestyleFactors === null || requestParameters.lifestyleFactors === undefined) {
            throw new runtime.RequiredError('LifestyleFactor','Required parameter requestParameters.lifestyleFactors was null or undefined when calling addOrEditHealthRecordLifestyleFactor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/lifestyle-factor`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.lifestyleFactors.map(LifestyleFactorToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addOrEditHealthRecordLifestyleFactorRequestOptionsRaw(requestParameters: AddOrEditHealthRecordLifestyleFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordLifestyleFactor.');
        }

        if (requestParameters.lifestyleFactors === null || requestParameters.lifestyleFactors === undefined) {
            throw new runtime.RequiredError('LifestyleFactor','Required parameter requestParameters.lifestyleFactors was null or undefined when calling addOrEditHealthRecordLifestyleFactor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/lifestyle-factor`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.lifestyleFactors.map(LifestyleFactorToJSON),
        };
        return responseConfig
    }

    /**
     * Updates or adds a new Lifestyle Factor in a particular Health Records  element (Roles: physician, admin)
     */
    async addOrEditHealthRecordLifestyleFactor(requestParameters: AddOrEditHealthRecordLifestyleFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.addOrEditHealthRecordLifestyleFactorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates or adds a new Patient Issue in a particular Health Records  element (Roles: physician, admin)
     */
    async addOrEditHealthRecordPatientIssueRaw(requestParameters: AddOrEditHealthRecordPatientIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordPatientIssue.');
        }

        if (requestParameters.field === null || requestParameters.field === undefined) {
            throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling addOrEditHealthRecordPatientIssue.');
        }

        if (requestParameters.patientIssues === null || requestParameters.patientIssues === undefined) {
            throw new runtime.RequiredError('PatientIssue','Required parameter requestParameters.patientIssues was null or undefined when calling addOrEditHealthRecordPatientIssue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/patient-issue/{field}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"field"}}`, encodeURIComponent(String(requestParameters.field))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patientIssues.map(PatientIssueToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addOrEditHealthRecordPatientIssueRequestOptionsRaw(requestParameters: AddOrEditHealthRecordPatientIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordPatientIssue.');
        }

        if (requestParameters.field === null || requestParameters.field === undefined) {
            throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling addOrEditHealthRecordPatientIssue.');
        }

        if (requestParameters.patientIssues === null || requestParameters.patientIssues === undefined) {
            throw new runtime.RequiredError('PatientIssue','Required parameter requestParameters.patientIssues was null or undefined when calling addOrEditHealthRecordPatientIssue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/patient-issue/{field}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"field"}}`, encodeURIComponent(String(requestParameters.field))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patientIssues.map(PatientIssueToJSON),
        };
        return responseConfig
    }

    /**
     * Updates or adds a new Patient Issue in a particular Health Records  element (Roles: physician, admin)
     */
    async addOrEditHealthRecordPatientIssue(requestParameters: AddOrEditHealthRecordPatientIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.addOrEditHealthRecordPatientIssueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates or adds a new Medication in a particular Health Records element  (Roles: physician, admin)
     */
    async addOrEditHealthRecordPatientMedicationRaw(requestParameters: AddOrEditHealthRecordPatientMedicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordPatientMedication.');
        }

        if (requestParameters.patientMedications === null || requestParameters.patientMedications === undefined) {
            throw new runtime.RequiredError('PatientMedication','Required parameter requestParameters.patientMedications was null or undefined when calling addOrEditHealthRecordPatientMedication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/patient-issue/medications`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patientMedications.map(PatientMedicationToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addOrEditHealthRecordPatientMedicationRequestOptionsRaw(requestParameters: AddOrEditHealthRecordPatientMedicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditHealthRecordPatientMedication.');
        }

        if (requestParameters.patientMedications === null || requestParameters.patientMedications === undefined) {
            throw new runtime.RequiredError('PatientMedication','Required parameter requestParameters.patientMedications was null or undefined when calling addOrEditHealthRecordPatientMedication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/patient-issue/medications`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patientMedications.map(PatientMedicationToJSON),
        };
        return responseConfig
    }

    /**
     * Updates or adds a new Medication in a particular Health Records element  (Roles: physician, admin)
     */
    async addOrEditHealthRecordPatientMedication(requestParameters: AddOrEditHealthRecordPatientMedicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.addOrEditHealthRecordPatientMedicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds or edits a medical order to the patient\'s records (roles)
     */
    async addOrEditMedicalOrderRaw(requestParameters: AddOrEditMedicalOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalOrder>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditMedicalOrder.');
        }

        if (requestParameters.medicalOrder === null || requestParameters.medicalOrder === undefined) {
            throw new runtime.RequiredError('MedicalOrder','Required parameter requestParameters.medicalOrder was null or undefined when calling addOrEditMedicalOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/medical-order`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MedicalOrderToJSON(requestParameters.medicalOrder),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalOrderFromJSON));
    }

    /**
        Request Config Getter
     */
    addOrEditMedicalOrderRequestOptionsRaw(requestParameters: AddOrEditMedicalOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling addOrEditMedicalOrder.');
        }

        if (requestParameters.medicalOrder === null || requestParameters.medicalOrder === undefined) {
            throw new runtime.RequiredError('MedicalOrder','Required parameter requestParameters.medicalOrder was null or undefined when calling addOrEditMedicalOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/medical-order`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: MedicalOrderToJSON(requestParameters.medicalOrder),
        };
        return responseConfig
    }

    /**
     * Adds or edits a medical order to the patient\'s records (roles)
     */
    async addOrEditMedicalOrder(requestParameters: AddOrEditMedicalOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicalOrder>> {
        const response = await this.addOrEditMedicalOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new Prescription health record (Roles: physician)
     */
    async addPrescriptionRaw(requestParameters: AddPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Prescription>> {
        if (requestParameters.prescription === null || requestParameters.prescription === undefined) {
            throw new runtime.RequiredError('Prescription','Required parameter requestParameters.prescription was null or undefined when calling addPrescription.');
        }

        const queryParameters: any = {};

        if (requestParameters.fax !== undefined) {
            queryParameters['fax'] = requestParameters.fax;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/prescriptions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionToJSON(requestParameters.prescription),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addPrescriptionRequestOptionsRaw(requestParameters: AddPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.prescription === null || requestParameters.prescription === undefined) {
            throw new runtime.RequiredError('Prescription','Required parameter requestParameters.prescription was null or undefined when calling addPrescription.');
        }

        const queryParameters: any = {};

        if (requestParameters.fax !== undefined) {
            queryParameters['fax'] = requestParameters.fax;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/prescriptions`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionToJSON(requestParameters.prescription),
        };
        return responseConfig
    }

    /**
     * Adds a new Prescription health record (Roles: physician)
     */
    async addPrescription(requestParameters: AddPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Prescription> {
        const response = await this.addPrescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new Prescription refill health record (Roles: patient)
     */
    async addPrescriptionRefillRaw(requestParameters: AddPrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionRefill>> {
        if (requestParameters.prescriptionRefill === null || requestParameters.prescriptionRefill === undefined) {
            throw new runtime.RequiredError('PrescriptionRefill','Required parameter requestParameters.prescriptionRefill was null or undefined when calling addPrescriptionRefill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/prescription-refill`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionRefillToJSON(requestParameters.prescriptionRefill),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionRefillFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addPrescriptionRefillRequestOptionsRaw(requestParameters: AddPrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.prescriptionRefill === null || requestParameters.prescriptionRefill === undefined) {
            throw new runtime.RequiredError('PrescriptionRefill','Required parameter requestParameters.prescriptionRefill was null or undefined when calling addPrescriptionRefill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/prescription-refill`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionRefillToJSON(requestParameters.prescriptionRefill),
        };
        return responseConfig
    }

    /**
     * Adds a new Prescription refill health record (Roles: patient)
     */
    async addPrescriptionRefill(requestParameters: AddPrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionRefill> {
        const response = await this.addPrescriptionRefillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new Referral health record (Roles: physician, admin)
     */
    async addReferralRaw(requestParameters: AddReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientDocument>> {
        if (requestParameters.referral === null || requestParameters.referral === undefined) {
            throw new runtime.RequiredError('Referral','Required parameter requestParameters.referral was null or undefined when calling addReferral.');
        }

        const queryParameters: any = {};

        if (requestParameters.fax !== undefined) {
            queryParameters['fax'] = requestParameters.fax;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/referrals/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters.referral),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientDocumentFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addReferralRequestOptionsRaw(requestParameters: AddReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.referral === null || requestParameters.referral === undefined) {
            throw new runtime.RequiredError('Referral','Required parameter requestParameters.referral was null or undefined when calling addReferral.');
        }

        const queryParameters: any = {};

        if (requestParameters.fax !== undefined) {
            queryParameters['fax'] = requestParameters.fax;
        }

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/referrals/`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters.referral),
        };
        return responseConfig
    }

    /**
     * Adds a new Referral health record (Roles: physician, admin)
     */
    async addReferral(requestParameters: AddReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientDocument> {
        const response = await this.addReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new Referral health record as an intern (Roles: physician)
     */
    async addReferralAsInternRaw(requestParameters: AddReferralAsInternRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Referral>> {
        if (requestParameters.referral === null || requestParameters.referral === undefined) {
            throw new runtime.RequiredError('Referral','Required parameter requestParameters.referral was null or undefined when calling addReferralAsIntern.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/referrals/intern`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters.referral),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addReferralAsInternRequestOptionsRaw(requestParameters: AddReferralAsInternRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.referral === null || requestParameters.referral === undefined) {
            throw new runtime.RequiredError('Referral','Required parameter requestParameters.referral was null or undefined when calling addReferralAsIntern.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/referrals/intern`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters.referral),
        };
        return responseConfig
    }

    /**
     * Adds a new Referral health record as an intern (Roles: physician)
     */
    async addReferralAsIntern(requestParameters: AddReferralAsInternRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Referral> {
        const response = await this.addReferralAsInternRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a Referral Request (Roles: physician)
     */
    async addReferralRequestRaw(requestParameters: AddReferralRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralRequest>> {
        if (requestParameters.referralRequest === null || requestParameters.referralRequest === undefined) {
            throw new runtime.RequiredError('ReferralRequest','Required parameter requestParameters.referralRequest was null or undefined when calling addReferralRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/referral-request/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralRequestToJSON(requestParameters.referralRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralRequestFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addReferralRequestRequestOptionsRaw(requestParameters: AddReferralRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.referralRequest === null || requestParameters.referralRequest === undefined) {
            throw new runtime.RequiredError('ReferralRequest','Required parameter requestParameters.referralRequest was null or undefined when calling addReferralRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/referral-request/`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ReferralRequestToJSON(requestParameters.referralRequest),
        };
        return responseConfig
    }

    /**
     * Adds a Referral Request (Roles: physician)
     */
    async addReferralRequest(requestParameters: AddReferralRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralRequest> {
        const response = await this.addReferralRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the Patient\'s count of unread health records (Roles: patient)
     */
    async countUnreadHealthRecordsRaw(requestParameters: CountUnreadHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CPPAndChatUnreadCount>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling countUnreadHealthRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/cpp/unread-count`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CPPAndChatUnreadCountFromJSON));
    }

    /**
        Request Config Getter
     */
    countUnreadHealthRecordsRequestOptionsRaw(requestParameters: CountUnreadHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling countUnreadHealthRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/cpp/unread-count`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns the Patient\'s count of unread health records (Roles: patient)
     */
    async countUnreadHealthRecords(requestParameters: CountUnreadHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CPPAndChatUnreadCount>> {
        const response = await this.countUnreadHealthRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a report document from markdown content and adds it to health records (Roles: physician)
     */
    async createReportDocumentRaw(requestParameters: CreateReportDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientDocument>> {
        if (requestParameters.createReportDocumentPayload === null || requestParameters.createReportDocumentPayload === undefined) {
            throw new runtime.RequiredError('CreateReportDocumentPayload','Required parameter requestParameters.createReportDocumentPayload was null or undefined when calling createReportDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReportDocumentPayloadToJSON(requestParameters.createReportDocumentPayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientDocumentFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    createReportDocumentRequestOptionsRaw(requestParameters: CreateReportDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.createReportDocumentPayload === null || requestParameters.createReportDocumentPayload === undefined) {
            throw new runtime.RequiredError('CreateReportDocumentPayload','Required parameter requestParameters.createReportDocumentPayload was null or undefined when calling createReportDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/reports`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: CreateReportDocumentPayloadToJSON(requestParameters.createReportDocumentPayload),
        };
        return responseConfig
    }

    /**
     * Creates a report document from markdown content and adds it to health records (Roles: physician)
     */
    async createReportDocument(requestParameters: CreateReportDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientDocument> {
        const response = await this.createReportDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * deletes an appointment note stamp
     */
    async deleteAppointmentNoteStampRaw(requestParameters: DeleteAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteAppointmentNoteStamp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/stamp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    deleteAppointmentNoteStampRequestOptionsRaw(requestParameters: DeleteAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteAppointmentNoteStamp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/stamp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * deletes an appointment note stamp
     */
    async deleteAppointmentNoteStamp(requestParameters: DeleteAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAppointmentNoteStampRaw(requestParameters, initOverrides);
    }

    /**
     * Removes a Consultant in a particular Health Records element (Roles:  physician, admin)
     */
    async deleteHealthRecordConsultantRaw(requestParameters: DeleteHealthRecordConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordConsultant.');
        }

        if (requestParameters.consultantId === null || requestParameters.consultantId === undefined) {
            throw new runtime.RequiredError('consultantId','Required parameter requestParameters.consultantId was null or undefined when calling deleteHealthRecordConsultant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/consultant/{consultantId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"consultantId"}}`, encodeURIComponent(String(requestParameters.consultantId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    deleteHealthRecordConsultantRequestOptionsRaw(requestParameters: DeleteHealthRecordConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordConsultant.');
        }

        if (requestParameters.consultantId === null || requestParameters.consultantId === undefined) {
            throw new runtime.RequiredError('consultantId','Required parameter requestParameters.consultantId was null or undefined when calling deleteHealthRecordConsultant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/consultant/{consultantId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"consultantId"}}`, encodeURIComponent(String(requestParameters.consultantId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a Consultant in a particular Health Records element (Roles:  physician, admin)
     */
    async deleteHealthRecordConsultant(requestParameters: DeleteHealthRecordConsultantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.deleteHealthRecordConsultantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a History Issue in a particular Health Records element (Roles:  physician, admin)
     */
    async deleteHealthRecordHistoryIssueRaw(requestParameters: DeleteHealthRecordHistoryIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordHistoryIssue.');
        }

        if (requestParameters.issueId === null || requestParameters.issueId === undefined) {
            throw new runtime.RequiredError('issueId','Required parameter requestParameters.issueId was null or undefined when calling deleteHealthRecordHistoryIssue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/history-issue/{issueId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"issueId"}}`, encodeURIComponent(String(requestParameters.issueId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    deleteHealthRecordHistoryIssueRequestOptionsRaw(requestParameters: DeleteHealthRecordHistoryIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordHistoryIssue.');
        }

        if (requestParameters.issueId === null || requestParameters.issueId === undefined) {
            throw new runtime.RequiredError('issueId','Required parameter requestParameters.issueId was null or undefined when calling deleteHealthRecordHistoryIssue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/history-issue/{issueId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"issueId"}}`, encodeURIComponent(String(requestParameters.issueId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a History Issue in a particular Health Records element (Roles:  physician, admin)
     */
    async deleteHealthRecordHistoryIssue(requestParameters: DeleteHealthRecordHistoryIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.deleteHealthRecordHistoryIssueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a Lifestyle Factor in a particular Health Records element  (Roles: physician, admin)
     */
    async deleteHealthRecordLifestyleFactorRaw(requestParameters: DeleteHealthRecordLifestyleFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordLifestyleFactor.');
        }

        if (requestParameters.factorId === null || requestParameters.factorId === undefined) {
            throw new runtime.RequiredError('factorId','Required parameter requestParameters.factorId was null or undefined when calling deleteHealthRecordLifestyleFactor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/lifestyle-factor/{factorId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"factorId"}}`, encodeURIComponent(String(requestParameters.factorId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    deleteHealthRecordLifestyleFactorRequestOptionsRaw(requestParameters: DeleteHealthRecordLifestyleFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordLifestyleFactor.');
        }

        if (requestParameters.factorId === null || requestParameters.factorId === undefined) {
            throw new runtime.RequiredError('factorId','Required parameter requestParameters.factorId was null or undefined when calling deleteHealthRecordLifestyleFactor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/lifestyle-factor/{factorId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"factorId"}}`, encodeURIComponent(String(requestParameters.factorId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a Lifestyle Factor in a particular Health Records element  (Roles: physician, admin)
     */
    async deleteHealthRecordLifestyleFactor(requestParameters: DeleteHealthRecordLifestyleFactorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.deleteHealthRecordLifestyleFactorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a Medication in a particular Health Records element (Roles:  physician, admin)
     */
    async deleteHealthRecordMedicationRaw(requestParameters: DeleteHealthRecordMedicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordMedication.');
        }

        if (requestParameters.medicationId === null || requestParameters.medicationId === undefined) {
            throw new runtime.RequiredError('medicationId','Required parameter requestParameters.medicationId was null or undefined when calling deleteHealthRecordMedication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/medication/{medicationId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"medicationId"}}`, encodeURIComponent(String(requestParameters.medicationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    deleteHealthRecordMedicationRequestOptionsRaw(requestParameters: DeleteHealthRecordMedicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordMedication.');
        }

        if (requestParameters.medicationId === null || requestParameters.medicationId === undefined) {
            throw new runtime.RequiredError('medicationId','Required parameter requestParameters.medicationId was null or undefined when calling deleteHealthRecordMedication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/medication/{medicationId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"medicationId"}}`, encodeURIComponent(String(requestParameters.medicationId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a Medication in a particular Health Records element (Roles:  physician, admin)
     */
    async deleteHealthRecordMedication(requestParameters: DeleteHealthRecordMedicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.deleteHealthRecordMedicationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a Patient Issue in a particular Health Records element (Roles:  physician, admin)
     */
    async deleteHealthRecordPatientIssueRaw(requestParameters: DeleteHealthRecordPatientIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordPatientIssue.');
        }

        if (requestParameters.field === null || requestParameters.field === undefined) {
            throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling deleteHealthRecordPatientIssue.');
        }

        if (requestParameters.issueId === null || requestParameters.issueId === undefined) {
            throw new runtime.RequiredError('issueId','Required parameter requestParameters.issueId was null or undefined when calling deleteHealthRecordPatientIssue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/patient-issue/{field}/{issueId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"field"}}`, encodeURIComponent(String(requestParameters.field))).replace(`{${"issueId"}}`, encodeURIComponent(String(requestParameters.issueId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    deleteHealthRecordPatientIssueRequestOptionsRaw(requestParameters: DeleteHealthRecordPatientIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteHealthRecordPatientIssue.');
        }

        if (requestParameters.field === null || requestParameters.field === undefined) {
            throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling deleteHealthRecordPatientIssue.');
        }

        if (requestParameters.issueId === null || requestParameters.issueId === undefined) {
            throw new runtime.RequiredError('issueId','Required parameter requestParameters.issueId was null or undefined when calling deleteHealthRecordPatientIssue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/patient-issue/{field}/{issueId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"field"}}`, encodeURIComponent(String(requestParameters.field))).replace(`{${"issueId"}}`, encodeURIComponent(String(requestParameters.issueId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a Patient Issue in a particular Health Records element (Roles:  physician, admin)
     */
    async deleteHealthRecordPatientIssue(requestParameters: DeleteHealthRecordPatientIssueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.deleteHealthRecordPatientIssueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a medical order
     */
    async deleteMedicalOrderRaw(requestParameters: DeleteMedicalOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicalOrder>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteMedicalOrder.');
        }

        if (requestParameters.date === null || requestParameters.date === undefined) {
            throw new runtime.RequiredError('date','Required parameter requestParameters.date was null or undefined when calling deleteMedicalOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = requestParameters.date;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/medical-order`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalOrderFromJSON));
    }

    /**
        Request Config Getter
     */
    deleteMedicalOrderRequestOptionsRaw(requestParameters: DeleteMedicalOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteMedicalOrder.');
        }

        if (requestParameters.date === null || requestParameters.date === undefined) {
            throw new runtime.RequiredError('date','Required parameter requestParameters.date was null or undefined when calling deleteMedicalOrder.');
        }

        const queryParameters: any = {};

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = requestParameters.date;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/medical-order`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes a medical order
     */
    async deleteMedicalOrder(requestParameters: DeleteMedicalOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicalOrder>> {
        const response = await this.deleteMedicalOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes an appointment note (Roles: physician, admin)
     */
    async deleteNoteRaw(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentNote>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentNoteFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    deleteNoteRequestOptionsRaw(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes an appointment note (Roles: physician, admin)
     */
    async deleteNote(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentNote> {
        const response = await this.deleteNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an appointment note draft (Roles: physician)
     */
    async deleteNotesDraftRaw(requestParameters: DeleteNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteNotesDraft.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteNotesDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/notes/draft/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    deleteNotesDraftRequestOptionsRaw(requestParameters: DeleteNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteNotesDraft.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteNotesDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/notes/draft/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes an appointment note draft (Roles: physician)
     */
    async deleteNotesDraft(requestParameters: DeleteNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteNotesDraftRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a referral (Roles: physician)
     */
    async deleteReferralRaw(requestParameters: DeleteReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteReferral.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/referrals/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    deleteReferralRequestOptionsRaw(requestParameters: DeleteReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling deleteReferral.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/referrals/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes a referral (Roles: physician)
     */
    async deleteReferral(requestParameters: DeleteReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteReferralRaw(requestParameters, initOverrides);
    }

    /**
     * Discontinues a medication reminder (Roles: patient)
     */
    async discontinueMedicationReminderRaw(requestParameters: DiscontinueMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicationReminder>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling discontinueMedicationReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/medication-reminder/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicationReminderFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    discontinueMedicationReminderRequestOptionsRaw(requestParameters: DiscontinueMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling discontinueMedicationReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/medication-reminder/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Discontinues a medication reminder (Roles: patient)
     */
    async discontinueMedicationReminder(requestParameters: DiscontinueMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicationReminder> {
        const response = await this.discontinueMedicationReminderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Edits an appointment note (Roles: physician)
     */
    async editNoteRaw(requestParameters: EditNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentNote>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling editNote.');
        }

        if (requestParameters.appointmentNote === null || requestParameters.appointmentNote === undefined) {
            throw new runtime.RequiredError('AppointmentNote','Required parameter requestParameters.appointmentNote was null or undefined when calling editNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentNoteToJSON(requestParameters.appointmentNote),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentNoteFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    editNoteRequestOptionsRaw(requestParameters: EditNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling editNote.');
        }

        if (requestParameters.appointmentNote === null || requestParameters.appointmentNote === undefined) {
            throw new runtime.RequiredError('AppointmentNote','Required parameter requestParameters.appointmentNote was null or undefined when calling editNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentNoteToJSON(requestParameters.appointmentNote),
        };
        return responseConfig
    }

    /**
     * Edits an appointment note (Roles: physician)
     */
    async editNote(requestParameters: EditNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentNote> {
        const response = await this.editNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Edits a Prescription refill health record (Roles: physician)
     */
    async editPrescriptionRefillRaw(requestParameters: EditPrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionRefill>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling editPrescriptionRefill.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling editPrescriptionRefill.');
        }

        if (requestParameters.prescriptionRefill === null || requestParameters.prescriptionRefill === undefined) {
            throw new runtime.RequiredError('PrescriptionRefill','Required parameter requestParameters.prescriptionRefill was null or undefined when calling editPrescriptionRefill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/prescription-refill/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionRefillToJSON(requestParameters.prescriptionRefill),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionRefillFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    editPrescriptionRefillRequestOptionsRaw(requestParameters: EditPrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling editPrescriptionRefill.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling editPrescriptionRefill.');
        }

        if (requestParameters.prescriptionRefill === null || requestParameters.prescriptionRefill === undefined) {
            throw new runtime.RequiredError('PrescriptionRefill','Required parameter requestParameters.prescriptionRefill was null or undefined when calling editPrescriptionRefill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/prescription-refill/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionRefillToJSON(requestParameters.prescriptionRefill),
        };
        return responseConfig
    }

    /**
     * Edits a Prescription refill health record (Roles: physician)
     */
    async editPrescriptionRefill(requestParameters: EditPrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionRefill> {
        const response = await this.editPrescriptionRefillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exports a PDF with the patient administered drugs (Roles: physician, admin, patient)
     */
    async exportAdministeredDrugsRaw(requestParameters: ExportAdministeredDrugsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling exportAdministeredDrugs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/administered-drugs/export`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    exportAdministeredDrugsRequestOptionsRaw(requestParameters: ExportAdministeredDrugsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling exportAdministeredDrugs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/administered-drugs/export`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Exports a PDF with the patient administered drugs (Roles: physician, admin, patient)
     */
    async exportAdministeredDrugs(requestParameters: ExportAdministeredDrugsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportAdministeredDrugsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exports a Patient\'s CPP (Roles: physician, admin)
     */
    async exportCPPRaw(requestParameters: ExportCPPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientDocument>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling exportCPP.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.excludeNotes !== undefined) {
            queryParameters['excludeNotes'] = requestParameters.excludeNotes;
        }

        if (requestParameters.excludeDocuments !== undefined) {
            queryParameters['excludeDocuments'] = requestParameters.excludeDocuments;
        }

        if (requestParameters.excludeSummary !== undefined) {
            queryParameters['excludeSummary'] = requestParameters.excludeSummary;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/cpp/export`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientDocumentFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    exportCPPRequestOptionsRaw(requestParameters: ExportCPPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling exportCPP.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.excludeNotes !== undefined) {
            queryParameters['excludeNotes'] = requestParameters.excludeNotes;
        }

        if (requestParameters.excludeDocuments !== undefined) {
            queryParameters['excludeDocuments'] = requestParameters.excludeDocuments;
        }

        if (requestParameters.excludeSummary !== undefined) {
            queryParameters['excludeSummary'] = requestParameters.excludeSummary;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/cpp/export`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Exports a Patient\'s CPP (Roles: physician, admin)
     */
    async exportCPP(requestParameters: ExportCPPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientDocument> {
        const response = await this.exportCPPRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exports a PDF with the patient immunizations (Roles: physician, admin, patient)
     */
    async exportImmunizationsRaw(requestParameters: ExportImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling exportImmunizations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/immunizations/export`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    exportImmunizationsRequestOptionsRaw(requestParameters: ExportImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling exportImmunizations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/immunizations/export`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Exports a PDF with the patient immunizations (Roles: physician, admin, patient)
     */
    async exportImmunizations(requestParameters: ExportImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportImmunizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates all future immunizations (Roles: physician, admin)
     */
    async generateImmunizationsRaw(requestParameters: GenerateImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Immunization>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling generateImmunizations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/immunizations/generate`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImmunizationFromJSON));
    }

    /**
        Request Config Getter
     */
    generateImmunizationsRequestOptionsRaw(requestParameters: GenerateImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling generateImmunizations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/immunizations/generate`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Generates all future immunizations (Roles: physician, admin)
     */
    async generateImmunizations(requestParameters: GenerateImmunizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Immunization>> {
        const response = await this.generateImmunizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets an appointment note stamp
     */
    async getAppointmentNoteStampRaw(requestParameters: GetAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentNoteStamp>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getAppointmentNoteStamp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/stamp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentNoteStampFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getAppointmentNoteStampRequestOptionsRaw(requestParameters: GetAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getAppointmentNoteStamp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/stamp/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets an appointment note stamp
     */
    async getAppointmentNoteStamp(requestParameters: GetAppointmentNoteStampRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentNoteStamp> {
        const response = await this.getAppointmentNoteStampRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * lists all stamps
     */
    async getAppointmentNoteStampsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentNoteStamp>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/stamp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentNoteStampFromJSON));
    }

    /**
        Request Config Getter
     */
    getAppointmentNoteStampsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/stamp`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * lists all stamps
     */
    async getAppointmentNoteStamps(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentNoteStamp>> {
        const response = await this.getAppointmentNoteStampsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a Patient\'s CPP (Roles: physician, patient, admin)
     */
    async getCPPRaw(requestParameters: GetCPPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CPP>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getCPP.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/cpp`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CPPFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getCPPRequestOptionsRaw(requestParameters: GetCPPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getCPP.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/cpp`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a Patient\'s CPP (Roles: physician, patient, admin)
     */
    async getCPP(requestParameters: GetCPPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CPP> {
        const response = await this.getCPPRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets HealthData for a specific metric (Roles: patient, physician, admin)
     */
    async getHealthDataSummaryRaw(requestParameters: GetHealthDataSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HealthRecordsMetricSummary>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getHealthDataSummary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/health-data/summary`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HealthRecordsMetricSummaryFromJSON));
    }

    /**
        Request Config Getter
     */
    getHealthDataSummaryRequestOptionsRaw(requestParameters: GetHealthDataSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getHealthDataSummary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/health-data/summary`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets HealthData for a specific metric (Roles: patient, physician, admin)
     */
    async getHealthDataSummary(requestParameters: GetHealthDataSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HealthRecordsMetricSummary>> {
        const response = await this.getHealthDataSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a Patient\'s generic health records (Roles: physician)
     */
    async getHealthRecordsRaw(requestParameters: GetHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getHealthRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getHealthRecordsRequestOptionsRaw(requestParameters: GetHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getHealthRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a Patient\'s generic health records (Roles: physician)
     */
    async getHealthRecords(requestParameters: GetHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.getHealthRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a description of the available immunizations (Roles: physician, admin)
     */
    async getImmunizationDescriptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ImmunizationDescription>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/immunizations/descriptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImmunizationDescriptionFromJSON));
    }

    /**
        Request Config Getter
     */
    getImmunizationDescriptionsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/immunizations/descriptions`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a description of the available immunizations (Roles: physician, admin)
     */
    async getImmunizationDescriptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ImmunizationDescription>> {
        const response = await this.getImmunizationDescriptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets latest HealthData for a specific metric and origin (Roles: patient)
     */
    async getLatestMetricValueRaw(requestParameters: GetLatestMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValue>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getLatestMetricValue.');
        }

        if (requestParameters.metric === null || requestParameters.metric === undefined) {
            throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling getLatestMetricValue.');
        }

        const queryParameters: any = {};

        if (requestParameters.origin !== undefined) {
            queryParameters['origin'] = requestParameters.origin;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/health-data/{metric}/latest`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"metric"}}`, encodeURIComponent(String(requestParameters.metric))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValueFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getLatestMetricValueRequestOptionsRaw(requestParameters: GetLatestMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getLatestMetricValue.');
        }

        if (requestParameters.metric === null || requestParameters.metric === undefined) {
            throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling getLatestMetricValue.');
        }

        const queryParameters: any = {};

        if (requestParameters.origin !== undefined) {
            queryParameters['origin'] = requestParameters.origin;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/health-data/{metric}/latest`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"metric"}}`, encodeURIComponent(String(requestParameters.metric))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets latest HealthData for a specific metric and origin (Roles: patient)
     */
    async getLatestMetricValue(requestParameters: GetLatestMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValue> {
        const response = await this.getLatestMetricValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets medication reminder notifications (Roles: patient)
     */
    async getMedicationReminderNotificationsRaw(requestParameters: GetMedicationReminderNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationReminderNotification>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patient_id','Required parameter requestParameters.patientId was null or undefined when calling getMedicationReminderNotifications.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getMedicationReminderNotifications.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getMedicationReminderNotifications.');
        }

        const queryParameters: any = {};

        if (requestParameters.patientId !== undefined) {
            queryParameters['patient_id'] = requestParameters.patientId;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.includeDiscontinued !== undefined) {
            queryParameters['include_discontinued'] = requestParameters.includeDiscontinued;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/medication-reminder/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationReminderNotificationFromJSON));
    }

    /**
        Request Config Getter
     */
    getMedicationReminderNotificationsRequestOptionsRaw(requestParameters: GetMedicationReminderNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patient_id','Required parameter requestParameters.patientId was null or undefined when calling getMedicationReminderNotifications.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getMedicationReminderNotifications.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getMedicationReminderNotifications.');
        }

        const queryParameters: any = {};

        if (requestParameters.patientId !== undefined) {
            queryParameters['patient_id'] = requestParameters.patientId;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.includeDiscontinued !== undefined) {
            queryParameters['include_discontinued'] = requestParameters.includeDiscontinued;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/medication-reminder/notifications`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets medication reminder notifications (Roles: patient)
     */
    async getMedicationReminderNotifications(requestParameters: GetMedicationReminderNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationReminderNotification>> {
        const response = await this.getMedicationReminderNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all medication reminders (Roles: patient)
     */
    async getMedicationRemindersRaw(requestParameters: GetMedicationRemindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationReminder>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patient_id','Required parameter requestParameters.patientId was null or undefined when calling getMedicationReminders.');
        }

        const queryParameters: any = {};

        if (requestParameters.patientId !== undefined) {
            queryParameters['patient_id'] = requestParameters.patientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/medication-reminder`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationReminderFromJSON));
    }

    /**
        Request Config Getter
     */
    getMedicationRemindersRequestOptionsRaw(requestParameters: GetMedicationRemindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patient_id','Required parameter requestParameters.patientId was null or undefined when calling getMedicationReminders.');
        }

        const queryParameters: any = {};

        if (requestParameters.patientId !== undefined) {
            queryParameters['patient_id'] = requestParameters.patientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/medication-reminder`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all medication reminders (Roles: patient)
     */
    async getMedicationReminders(requestParameters: GetMedicationRemindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationReminder>> {
        const response = await this.getMedicationRemindersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets latest menstruation data (Roles: patient)
     */
    async getMenstruationDataRaw(requestParameters: GetMenstruationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MTUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getMenstruationData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/menstruation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MTUpdateFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getMenstruationDataRequestOptionsRaw(requestParameters: GetMenstruationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getMenstruationData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/menstruation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets latest menstruation data (Roles: patient)
     */
    async getMenstruationData(requestParameters: GetMenstruationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MTUpdate> {
        const response = await this.getMenstruationDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets available menstruation reminders (Roles: patient)
     */
    async getMenstruationRemindersDescriptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MTReminderDescription>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/menstruation/reminders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MTReminderDescriptionFromJSON));
    }

    /**
        Request Config Getter
     */
    getMenstruationRemindersDescriptionsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/menstruation/reminders`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets available menstruation reminders (Roles: patient)
     */
    async getMenstruationRemindersDescriptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MTReminderDescription>> {
        const response = await this.getMenstruationRemindersDescriptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all MetricTypes (Roles: patient, physician, admin)
     */
    async getMetricTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MetricType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/metric-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MetricTypeFromJSON));
    }

    /**
        Request Config Getter
     */
    getMetricTypesRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/metric-types`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all MetricTypes (Roles: patient, physician, admin)
     */
    async getMetricTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MetricType>> {
        const response = await this.getMetricTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a notes\' attachment (Roles: physician, patient, admin)
     */
    async getNotesAttachmentRaw(requestParameters: GetNotesAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.appointmentNoteId === null || requestParameters.appointmentNoteId === undefined) {
            throw new runtime.RequiredError('appointmentNoteId','Required parameter requestParameters.appointmentNoteId was null or undefined when calling getNotesAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/attachment/{appointmentNoteId}`.replace(`{${"appointmentNoteId"}}`, encodeURIComponent(String(requestParameters.appointmentNoteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    getNotesAttachmentRequestOptionsRaw(requestParameters: GetNotesAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.appointmentNoteId === null || requestParameters.appointmentNoteId === undefined) {
            throw new runtime.RequiredError('appointmentNoteId','Required parameter requestParameters.appointmentNoteId was null or undefined when calling getNotesAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/attachment/{appointmentNoteId}`.replace(`{${"appointmentNoteId"}}`, encodeURIComponent(String(requestParameters.appointmentNoteId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a notes\' attachment (Roles: physician, patient, admin)
     */
    async getNotesAttachment(requestParameters: GetNotesAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getNotesAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets own note draft (Roles: physician)
     */
    async getOwnDraftsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentNoteDraft>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/notes/draft/own`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentNoteDraftFromJSON));
    }

    /**
        Request Config Getter
     */
    getOwnDraftsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/notes/draft/own`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets own note draft (Roles: physician)
     */
    async getOwnDrafts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentNoteDraft>> {
        const response = await this.getOwnDraftsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a all pending records by the practitioner\'s interns (Roles: physician)
     */
    async getOwnInternsPendingRecordsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InternPendingRecords>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/interns/pending`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternPendingRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getOwnInternsPendingRecordsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/interns/pending`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a all pending records by the practitioner\'s interns (Roles: physician)
     */
    async getOwnInternsPendingRecords(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InternPendingRecords> {
        const response = await this.getOwnInternsPendingRecordsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a patient\'s appointment note drafts (Roles: physician)
     */
    async getPatientNotesDraftRaw(requestParameters: GetPatientNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentNoteDraft>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getPatientNotesDraft.');
        }

        const queryParameters: any = {};

        if (requestParameters.backups !== undefined) {
            queryParameters['backups'] = requestParameters.backups;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/notes/draft`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentNoteDraftFromJSON));
    }

    /**
        Request Config Getter
     */
    getPatientNotesDraftRequestOptionsRaw(requestParameters: GetPatientNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getPatientNotesDraft.');
        }

        const queryParameters: any = {};

        if (requestParameters.backups !== undefined) {
            queryParameters['backups'] = requestParameters.backups;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/notes/draft`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a patient\'s appointment note drafts (Roles: physician)
     */
    async getPatientNotesDraft(requestParameters: GetPatientNotesDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentNoteDraft>> {
        const response = await this.getPatientNotesDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets pending Referral health records (Roles: physician, admin)
     */
    async getPendingReferralsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientDocument>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/referrals/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientDocumentFromJSON));
    }

    /**
        Request Config Getter
     */
    getPendingReferralsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/referrals/`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets pending Referral health records (Roles: physician, admin)
     */
    async getPendingReferrals(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientDocument>> {
        const response = await this.getPendingReferralsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the attachment of the prescription (Roles: patient, physician, admin)
     */
    async getPrescriptionAttachmentRaw(requestParameters: GetPrescriptionAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getPrescriptionAttachment.');
        }

        if (requestParameters.prescriptionId === null || requestParameters.prescriptionId === undefined) {
            throw new runtime.RequiredError('prescriptionId','Required parameter requestParameters.prescriptionId was null or undefined when calling getPrescriptionAttachment.');
        }

        if (requestParameters.resource === null || requestParameters.resource === undefined) {
            throw new runtime.RequiredError('Resource','Required parameter requestParameters.resource was null or undefined when calling getPrescriptionAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/prescriptions/{prescriptionId}/get-attachment`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters.prescriptionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResourceToJSON(requestParameters.resource),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    getPrescriptionAttachmentRequestOptionsRaw(requestParameters: GetPrescriptionAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getPrescriptionAttachment.');
        }

        if (requestParameters.prescriptionId === null || requestParameters.prescriptionId === undefined) {
            throw new runtime.RequiredError('prescriptionId','Required parameter requestParameters.prescriptionId was null or undefined when calling getPrescriptionAttachment.');
        }

        if (requestParameters.resource === null || requestParameters.resource === undefined) {
            throw new runtime.RequiredError('Resource','Required parameter requestParameters.resource was null or undefined when calling getPrescriptionAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/prescriptions/{prescriptionId}/get-attachment`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters.prescriptionId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ResourceToJSON(requestParameters.resource),
        };
        return responseConfig
    }

    /**
     * Gets the attachment of the prescription (Roles: patient, physician, admin)
     */
    async getPrescriptionAttachment(requestParameters: GetPrescriptionAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getPrescriptionAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the pdf of the prescription (Roles: patient, physician, admin)
     */
    async getPrescriptionPDFRaw(requestParameters: GetPrescriptionPDFRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getPrescriptionPDF.');
        }

        if (requestParameters.prescriptionId === null || requestParameters.prescriptionId === undefined) {
            throw new runtime.RequiredError('prescriptionId','Required parameter requestParameters.prescriptionId was null or undefined when calling getPrescriptionPDF.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/prescriptions/{prescriptionId}/pdf`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters.prescriptionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    getPrescriptionPDFRequestOptionsRaw(requestParameters: GetPrescriptionPDFRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getPrescriptionPDF.');
        }

        if (requestParameters.prescriptionId === null || requestParameters.prescriptionId === undefined) {
            throw new runtime.RequiredError('prescriptionId','Required parameter requestParameters.prescriptionId was null or undefined when calling getPrescriptionPDF.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/prescriptions/{prescriptionId}/pdf`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters.prescriptionId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the pdf of the prescription (Roles: patient, physician, admin)
     */
    async getPrescriptionPDF(requestParameters: GetPrescriptionPDFRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getPrescriptionPDFRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all Prescription refills (Roles: physician)
     */
    async getPrescriptionRefillsRaw(requestParameters: GetPrescriptionRefillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PrescriptionRefill>>> {
        const queryParameters: any = {};

        if (requestParameters.clinicId !== undefined) {
            queryParameters['clinicId'] = requestParameters.clinicId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/prescription-refill`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrescriptionRefillFromJSON));
    }

    /**
        Request Config Getter
     */
    getPrescriptionRefillsRequestOptionsRaw(requestParameters: GetPrescriptionRefillsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.clinicId !== undefined) {
            queryParameters['clinicId'] = requestParameters.clinicId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/prescription-refill`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all Prescription refills (Roles: physician)
     */
    async getPrescriptionRefills(requestParameters: GetPrescriptionRefillsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PrescriptionRefill>> {
        const response = await this.getPrescriptionRefillsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the Referral Requests for the user\'s clinic (Roles: admin)
     */
    async getReferralRequestsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReferralRequest>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/referral-request/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferralRequestFromJSON));
    }

    /**
        Request Config Getter
     */
    getReferralRequestsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/referral-request/`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the Referral Requests for the user\'s clinic (Roles: admin)
     */
    async getReferralRequests(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReferralRequest>> {
        const response = await this.getReferralRequestsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets Referral health records by status (Roles: physician, admin)
     */
    async getReferralsByStatusRaw(requestParameters: GetReferralsByStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientDocument>>> {
        if (requestParameters.status === null || requestParameters.status === undefined) {
            throw new runtime.RequiredError('status','Required parameter requestParameters.status was null or undefined when calling getReferralsByStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/referrals/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientDocumentFromJSON));
    }

    /**
        Request Config Getter
     */
    getReferralsByStatusRequestOptionsRaw(requestParameters: GetReferralsByStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.status === null || requestParameters.status === undefined) {
            throw new runtime.RequiredError('status','Required parameter requestParameters.status was null or undefined when calling getReferralsByStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/referrals/status`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets Referral health records by status (Roles: physician, admin)
     */
    async getReferralsByStatus(requestParameters: GetReferralsByStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientDocument>> {
        const response = await this.getReferralsByStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets HealthData for a specific metric (Roles: patient, physician, admin)
     */
    async getSpecificHealthDataRaw(requestParameters: GetSpecificHealthDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecordsMetricAggregated>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getSpecificHealthData.');
        }

        if (requestParameters.metric === null || requestParameters.metric === undefined) {
            throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling getSpecificHealthData.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.origin !== undefined) {
            queryParameters['origin'] = requestParameters.origin;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/health-data/{metric}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"metric"}}`, encodeURIComponent(String(requestParameters.metric))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsMetricAggregatedFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getSpecificHealthDataRequestOptionsRaw(requestParameters: GetSpecificHealthDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getSpecificHealthData.');
        }

        if (requestParameters.metric === null || requestParameters.metric === undefined) {
            throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling getSpecificHealthData.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.origin !== undefined) {
            queryParameters['origin'] = requestParameters.origin;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/health-data/{metric}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"metric"}}`, encodeURIComponent(String(requestParameters.metric))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets HealthData for a specific metric (Roles: patient, physician, admin)
     */
    async getSpecificHealthData(requestParameters: GetSpecificHealthDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecordsMetricAggregated> {
        const response = await this.getSpecificHealthDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the list of prefilled Care& Vitality Drugs (Roles: physician, admin)
     */
    async getVitalityDrugDescriptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VitalityDrugDescription>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/vitality-drugs/descriptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VitalityDrugDescriptionFromJSON));
    }

    /**
        Request Config Getter
     */
    getVitalityDrugDescriptionsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/vitality-drugs/descriptions`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the list of prefilled Care& Vitality Drugs (Roles: physician, admin)
     */
    async getVitalityDrugDescriptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VitalityDrugDescription>> {
        const response = await this.getVitalityDrugDescriptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Marks all health records as read (Roles: patient)
     */
    async markAllHealthRecordsReadRaw(requestParameters: MarkAllHealthRecordsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CPP>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling markAllHealthRecordsRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/mark-read`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CPPFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    markAllHealthRecordsReadRequestOptionsRaw(requestParameters: MarkAllHealthRecordsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling markAllHealthRecordsRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/mark-read`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Marks all health records as read (Roles: patient)
     */
    async markAllHealthRecordsRead(requestParameters: MarkAllHealthRecordsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CPP> {
        const response = await this.markAllHealthRecordsReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks a health record element as read (Roles: patient)
     */
    async markHealthRecordReadRaw(requestParameters: MarkHealthRecordReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling markHealthRecordRead.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling markHealthRecordRead.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling markHealthRecordRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/mark-read/{type}/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    markHealthRecordReadRequestOptionsRaw(requestParameters: MarkHealthRecordReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling markHealthRecordRead.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling markHealthRecordRead.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling markHealthRecordRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/mark-read/{type}/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Marks a health record element as read (Roles: patient)
     */
    async markHealthRecordRead(requestParameters: MarkHealthRecordReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markHealthRecordReadRaw(requestParameters, initOverrides);
    }

    /**
     * Generates a PDF preview of the Prescription (Roles: physician)
     */
    async previewPrescriptionRaw(requestParameters: PreviewPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.prescription === null || requestParameters.prescription === undefined) {
            throw new runtime.RequiredError('Prescription','Required parameter requestParameters.prescription was null or undefined when calling previewPrescription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/prescriptions/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionToJSON(requestParameters.prescription),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    previewPrescriptionRequestOptionsRaw(requestParameters: PreviewPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.prescription === null || requestParameters.prescription === undefined) {
            throw new runtime.RequiredError('Prescription','Required parameter requestParameters.prescription was null or undefined when calling previewPrescription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/prescriptions/preview`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionToJSON(requestParameters.prescription),
        };
        return responseConfig
    }

    /**
     * Generates a PDF preview of the Prescription (Roles: physician)
     */
    async previewPrescription(requestParameters: PreviewPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.previewPrescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a PDF preview of the Referral (Roles: physician)
     */
    async previewReferralRaw(requestParameters: PreviewReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.referral === null || requestParameters.referral === undefined) {
            throw new runtime.RequiredError('Referral','Required parameter requestParameters.referral was null or undefined when calling previewReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/referrals/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters.referral),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    previewReferralRequestOptionsRaw(requestParameters: PreviewReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.referral === null || requestParameters.referral === undefined) {
            throw new runtime.RequiredError('Referral','Required parameter requestParameters.referral was null or undefined when calling previewReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/referrals/preview`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ReferralToJSON(requestParameters.referral),
        };
        return responseConfig
    }

    /**
     * Generates a PDF preview of the Referral (Roles: physician)
     */
    async previewReferral(requestParameters: PreviewReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.previewReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an Administered Drug health record (Roles: physician)
     */
    async removeAdministeredDrugRaw(requestParameters: RemoveAdministeredDrugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdministeredDrug>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeAdministeredDrug.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removeAdministeredDrug.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/administered-drugs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdministeredDrugFromJSON));
    }

    /**
        Request Config Getter
     */
    removeAdministeredDrugRequestOptionsRaw(requestParameters: RemoveAdministeredDrugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeAdministeredDrug.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removeAdministeredDrug.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/administered-drugs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes an Administered Drug health record (Roles: physician)
     */
    async removeAdministeredDrug(requestParameters: RemoveAdministeredDrugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdministeredDrug>> {
        const response = await this.removeAdministeredDrugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an Immunization health record (Roles: physician)
     */
    async removeImmunizationRaw(requestParameters: RemoveImmunizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Immunization>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeImmunization.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removeImmunization.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/immunizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImmunizationFromJSON));
    }

    /**
        Request Config Getter
     */
    removeImmunizationRequestOptionsRaw(requestParameters: RemoveImmunizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeImmunization.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removeImmunization.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/immunizations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes an Immunization health record (Roles: physician)
     */
    async removeImmunization(requestParameters: RemoveImmunizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Immunization>> {
        const response = await this.removeImmunizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a prescription (Roles: physician)
     */
    async removePrescriptionRaw(requestParameters: RemovePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removePrescription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/prescriptions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    removePrescriptionRequestOptionsRaw(requestParameters: RemovePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removePrescription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/prescriptions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes a prescription (Roles: physician)
     */
    async removePrescription(requestParameters: RemovePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePrescriptionRaw(requestParameters, initOverrides);
    }

    /**
     * Rejects a new Prescription refill (Roles: physician)
     */
    async removePrescriptionRefillRaw(requestParameters: RemovePrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionRefill>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removePrescriptionRefill.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removePrescriptionRefill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/prescription-refill/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionRefillFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    removePrescriptionRefillRequestOptionsRaw(requestParameters: RemovePrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removePrescriptionRefill.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling removePrescriptionRefill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/prescription-refill/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Rejects a new Prescription refill (Roles: physician)
     */
    async removePrescriptionRefill(requestParameters: RemovePrescriptionRefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionRefill> {
        const response = await this.removePrescriptionRefillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a new Referral health record (Roles: physician, admin)
     */
    async removeReferralRequestRaw(requestParameters: RemoveReferralRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeReferralRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/referral-request/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    removeReferralRequestRequestOptionsRaw(requestParameters: RemoveReferralRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeReferralRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/referral-request/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a new Referral health record (Roles: physician, admin)
     */
    async removeReferralRequest(requestParameters: RemoveReferralRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeReferralRequestRaw(requestParameters, initOverrides);
    }

    /**
     * Resets menstruation data (Roles: patient)
     */
    async resetMenstruationDataRaw(requestParameters: ResetMenstruationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Patient>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling resetMenstruationData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/menstruation/{id}/reset`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    resetMenstruationDataRequestOptionsRaw(requestParameters: ResetMenstruationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling resetMenstruationData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/menstruation/{id}/reset`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Resets menstruation data (Roles: patient)
     */
    async resetMenstruationData(requestParameters: ResetMenstruationDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Patient> {
        const response = await this.resetMenstruationDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches the HR for patients on the practitioner\'s roster, you can  search for medical conditions, medications, etc. (Roles: physician)
     */
    async searchHealthRecordsRaw(requestParameters: SearchHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HealthRecords>>> {
        if (requestParameters.term === null || requestParameters.term === undefined) {
            throw new runtime.RequiredError('term','Required parameter requestParameters.term was null or undefined when calling searchHealthRecords.');
        }

        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling searchHealthRecords.');
        }

        if (requestParameters.multipleValuesPayload === null || requestParameters.multipleValuesPayload === undefined) {
            throw new runtime.RequiredError('MultipleValuesPayload','Required parameter requestParameters.multipleValuesPayload was null or undefined when calling searchHealthRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/search/{physicianId}/{term}`.replace(`{${"term"}}`, encodeURIComponent(String(requestParameters.term))).replace(`{${"physicianId"}}`, encodeURIComponent(String(requestParameters.physicianId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MultipleValuesPayloadToJSON(requestParameters.multipleValuesPayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HealthRecordsFromJSON));
    }

    /**
        Request Config Getter
     */
    searchHealthRecordsRequestOptionsRaw(requestParameters: SearchHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.term === null || requestParameters.term === undefined) {
            throw new runtime.RequiredError('term','Required parameter requestParameters.term was null or undefined when calling searchHealthRecords.');
        }

        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling searchHealthRecords.');
        }

        if (requestParameters.multipleValuesPayload === null || requestParameters.multipleValuesPayload === undefined) {
            throw new runtime.RequiredError('MultipleValuesPayload','Required parameter requestParameters.multipleValuesPayload was null or undefined when calling searchHealthRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/search/{physicianId}/{term}`.replace(`{${"term"}}`, encodeURIComponent(String(requestParameters.term))).replace(`{${"physicianId"}}`, encodeURIComponent(String(requestParameters.physicianId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: MultipleValuesPayloadToJSON(requestParameters.multipleValuesPayload),
        };
        return responseConfig
    }

    /**
     * Searches the HR for patients on the practitioner\'s roster, you can  search for medical conditions, medications, etc. (Roles: physician)
     */
    async searchHealthRecords(requestParameters: SearchHealthRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HealthRecords>> {
        const response = await this.searchHealthRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Snoozes a medication reminder (Roles: patient)
     */
    async snoozeMedicationReminderRaw(requestParameters: SnoozeMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.duration === null || requestParameters.duration === undefined) {
            throw new runtime.RequiredError('duration','Required parameter requestParameters.duration was null or undefined when calling snoozeMedicationReminder.');
        }

        if (requestParameters.medicationReminderNotification === null || requestParameters.medicationReminderNotification === undefined) {
            throw new runtime.RequiredError('MedicationReminderNotification','Required parameter requestParameters.medicationReminderNotification was null or undefined when calling snoozeMedicationReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/medication-reminder/snooze/{duration}`.replace(`{${"duration"}}`, encodeURIComponent(String(requestParameters.duration))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MedicationReminderNotificationToJSON(requestParameters.medicationReminderNotification),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    snoozeMedicationReminderRequestOptionsRaw(requestParameters: SnoozeMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.duration === null || requestParameters.duration === undefined) {
            throw new runtime.RequiredError('duration','Required parameter requestParameters.duration was null or undefined when calling snoozeMedicationReminder.');
        }

        if (requestParameters.medicationReminderNotification === null || requestParameters.medicationReminderNotification === undefined) {
            throw new runtime.RequiredError('MedicationReminderNotification','Required parameter requestParameters.medicationReminderNotification was null or undefined when calling snoozeMedicationReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/medication-reminder/snooze/{duration}`.replace(`{${"duration"}}`, encodeURIComponent(String(requestParameters.duration))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: MedicationReminderNotificationToJSON(requestParameters.medicationReminderNotification),
        };
        return responseConfig
    }

    /**
     * Snoozes a medication reminder (Roles: patient)
     */
    async snoozeMedicationReminder(requestParameters: SnoozeMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.snoozeMedicationReminderRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the health records information object (Roles: physician, admin)
     */
    async updateHealthRecordsInformationRaw(requestParameters: UpdateHealthRecordsInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthRecords>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updateHealthRecordsInformation.');
        }

        if (requestParameters.healthRecordsInformation === null || requestParameters.healthRecordsInformation === undefined) {
            throw new runtime.RequiredError('HealthRecordsInformation','Required parameter requestParameters.healthRecordsInformation was null or undefined when calling updateHealthRecordsInformation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/information`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HealthRecordsInformationToJSON(requestParameters.healthRecordsInformation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthRecordsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateHealthRecordsInformationRequestOptionsRaw(requestParameters: UpdateHealthRecordsInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updateHealthRecordsInformation.');
        }

        if (requestParameters.healthRecordsInformation === null || requestParameters.healthRecordsInformation === undefined) {
            throw new runtime.RequiredError('HealthRecordsInformation','Required parameter requestParameters.healthRecordsInformation was null or undefined when calling updateHealthRecordsInformation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/information`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: HealthRecordsInformationToJSON(requestParameters.healthRecordsInformation),
        };
        return responseConfig
    }

    /**
     * Updates the health records information object (Roles: physician, admin)
     */
    async updateHealthRecordsInformation(requestParameters: UpdateHealthRecordsInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthRecords> {
        const response = await this.updateHealthRecordsInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a medication reminder (Roles: patient)
     */
    async updateMedicationReminderRaw(requestParameters: UpdateMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationReminder>>> {
        if (requestParameters.medicationReminder === null || requestParameters.medicationReminder === undefined) {
            throw new runtime.RequiredError('MedicationReminder','Required parameter requestParameters.medicationReminder was null or undefined when calling updateMedicationReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/medication-reminder`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MedicationReminderToJSON(requestParameters.medicationReminder),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationReminderFromJSON));
    }

    /**
        Request Config Getter
     */
    updateMedicationReminderRequestOptionsRaw(requestParameters: UpdateMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.medicationReminder === null || requestParameters.medicationReminder === undefined) {
            throw new runtime.RequiredError('MedicationReminder','Required parameter requestParameters.medicationReminder was null or undefined when calling updateMedicationReminder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/medication-reminder`,
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: MedicationReminderToJSON(requestParameters.medicationReminder),
        };
        return responseConfig
    }

    /**
     * Updates a medication reminder (Roles: patient)
     */
    async updateMedicationReminder(requestParameters: UpdateMedicationReminderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationReminder>> {
        const response = await this.updateMedicationReminderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * adds or removes a take from a medication reminder (Roles: patient)
     */
    async updateMedicationReminderTakeRaw(requestParameters: UpdateMedicationReminderTakeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicationReminder>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateMedicationReminderTake.');
        }

        if (requestParameters.medicationReminderTake === null || requestParameters.medicationReminderTake === undefined) {
            throw new runtime.RequiredError('MedicationReminderTake','Required parameter requestParameters.medicationReminderTake was null or undefined when calling updateMedicationReminderTake.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/medication-reminder/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MedicationReminderTakeToJSON(requestParameters.medicationReminderTake),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicationReminderFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateMedicationReminderTakeRequestOptionsRaw(requestParameters: UpdateMedicationReminderTakeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateMedicationReminderTake.');
        }

        if (requestParameters.medicationReminderTake === null || requestParameters.medicationReminderTake === undefined) {
            throw new runtime.RequiredError('MedicationReminderTake','Required parameter requestParameters.medicationReminderTake was null or undefined when calling updateMedicationReminderTake.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/medication-reminder/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: MedicationReminderTakeToJSON(requestParameters.medicationReminderTake),
        };
        return responseConfig
    }

    /**
     * adds or removes a take from a medication reminder (Roles: patient)
     */
    async updateMedicationReminderTake(requestParameters: UpdateMedicationReminderTakeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicationReminder> {
        const response = await this.updateMedicationReminderTakeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates multiple menstruation events (Roles: patient)
     */
    async updateMenstruationDatesRaw(requestParameters: UpdateMenstruationDatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MTUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateMenstruationDates.');
        }

        if (requestParameters.mTDates === null || requestParameters.mTDates === undefined) {
            throw new runtime.RequiredError('MTDate','Required parameter requestParameters.mTDates was null or undefined when calling updateMenstruationDates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/menstruation/{id}/bulk`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mTDates.map(MTDateToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MTUpdateFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateMenstruationDatesRequestOptionsRaw(requestParameters: UpdateMenstruationDatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateMenstruationDates.');
        }

        if (requestParameters.mTDates === null || requestParameters.mTDates === undefined) {
            throw new runtime.RequiredError('MTDate','Required parameter requestParameters.mTDates was null or undefined when calling updateMenstruationDates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/menstruation/{id}/bulk`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mTDates.map(MTDateToJSON),
        };
        return responseConfig
    }

    /**
     * Updates multiple menstruation events (Roles: patient)
     */
    async updateMenstruationDates(requestParameters: UpdateMenstruationDatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MTUpdate> {
        const response = await this.updateMenstruationDatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the menstruation tutorial data (Roles: patient)
     */
    async updateMenstruationTutorialDataRaw(requestParameters: UpdateMenstruationTutorialDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MTUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateMenstruationTutorialData.');
        }

        if (requestParameters.mTTutorialData === null || requestParameters.mTTutorialData === undefined) {
            throw new runtime.RequiredError('MTTutorialData','Required parameter requestParameters.mTTutorialData was null or undefined when calling updateMenstruationTutorialData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/menstruation/{id}/tutorial`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MTTutorialDataToJSON(requestParameters.mTTutorialData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MTUpdateFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateMenstruationTutorialDataRequestOptionsRaw(requestParameters: UpdateMenstruationTutorialDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateMenstruationTutorialData.');
        }

        if (requestParameters.mTTutorialData === null || requestParameters.mTTutorialData === undefined) {
            throw new runtime.RequiredError('MTTutorialData','Required parameter requestParameters.mTTutorialData was null or undefined when calling updateMenstruationTutorialData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/menstruation/{id}/tutorial`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: MTTutorialDataToJSON(requestParameters.mTTutorialData),
        };
        return responseConfig
    }

    /**
     * Updates the menstruation tutorial data (Roles: patient)
     */
    async updateMenstruationTutorialData(requestParameters: UpdateMenstruationTutorialDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MTUpdate> {
        const response = await this.updateMenstruationTutorialDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a Prescription (Roles: physician)
     */
    async updatePrescriptionRaw(requestParameters: UpdatePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Prescription>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updatePrescription.');
        }

        if (requestParameters.prescriptionId === null || requestParameters.prescriptionId === undefined) {
            throw new runtime.RequiredError('prescriptionId','Required parameter requestParameters.prescriptionId was null or undefined when calling updatePrescription.');
        }

        if (requestParameters.prescription === null || requestParameters.prescription === undefined) {
            throw new runtime.RequiredError('Prescription','Required parameter requestParameters.prescription was null or undefined when calling updatePrescription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/prescriptions/{prescriptionId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters.prescriptionId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionToJSON(requestParameters.prescription),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updatePrescriptionRequestOptionsRaw(requestParameters: UpdatePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updatePrescription.');
        }

        if (requestParameters.prescriptionId === null || requestParameters.prescriptionId === undefined) {
            throw new runtime.RequiredError('prescriptionId','Required parameter requestParameters.prescriptionId was null or undefined when calling updatePrescription.');
        }

        if (requestParameters.prescription === null || requestParameters.prescription === undefined) {
            throw new runtime.RequiredError('Prescription','Required parameter requestParameters.prescription was null or undefined when calling updatePrescription.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/prescriptions/{prescriptionId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters.prescriptionId))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PrescriptionToJSON(requestParameters.prescription),
        };
        return responseConfig
    }

    /**
     * Updates a Prescription (Roles: physician)
     */
    async updatePrescription(requestParameters: UpdatePrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Prescription> {
        const response = await this.updatePrescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a referral (Roles: physician, admin)
     */
    async updateReferralRaw(requestParameters: UpdateReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientDocument>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updateReferral.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateReferral.');
        }

        if (requestParameters.patientDocument === null || requestParameters.patientDocument === undefined) {
            throw new runtime.RequiredError('PatientDocument','Required parameter requestParameters.patientDocument was null or undefined when calling updateReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/health-records/{patientId}/referrals/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PatientDocumentToJSON(requestParameters.patientDocument),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientDocumentFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateReferralRequestOptionsRaw(requestParameters: UpdateReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling updateReferral.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateReferral.');
        }

        if (requestParameters.patientDocument === null || requestParameters.patientDocument === undefined) {
            throw new runtime.RequiredError('PatientDocument','Required parameter requestParameters.patientDocument was null or undefined when calling updateReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/health-records/{patientId}/referrals/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PatientDocumentToJSON(requestParameters.patientDocument),
        };
        return responseConfig
    }

    /**
     * Updates a referral (Roles: physician, admin)
     */
    async updateReferral(requestParameters: UpdateReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientDocument> {
        const response = await this.updateReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const AddOrEditHealthRecordPatientIssueFieldEnum = {
    Medications: 'medications',
    ActiveIssues: 'active_issues',
    MedicalIssues: 'medical_issues',
    Allergies: 'allergies',
    Notes: 'notes',
    PreventativeScreenings: 'preventative_screenings'
} as const;
export type AddOrEditHealthRecordPatientIssueFieldEnum = typeof AddOrEditHealthRecordPatientIssueFieldEnum[keyof typeof AddOrEditHealthRecordPatientIssueFieldEnum];
/**
 * @export
 */
export const DeleteHealthRecordPatientIssueFieldEnum = {
    ActiveIssues: 'active_issues',
    MedicalIssues: 'medical_issues',
    Allergies: 'allergies',
    Notes: 'notes',
    PreventativeScreenings: 'preventative_screenings'
} as const;
export type DeleteHealthRecordPatientIssueFieldEnum = typeof DeleteHealthRecordPatientIssueFieldEnum[keyof typeof DeleteHealthRecordPatientIssueFieldEnum];
/**
 * @export
 */
export const GetLatestMetricValueOriginEnum = {
    AppleHealth: 'Apple Health',
    AndroidHealth: 'Android Health',
    Lab: 'Lab',
    Practitioner: 'Practitioner'
} as const;
export type GetLatestMetricValueOriginEnum = typeof GetLatestMetricValueOriginEnum[keyof typeof GetLatestMetricValueOriginEnum];
/**
 * @export
 */
export const GetReferralsByStatusStatusEnum = {
    PendingSend: 'Pending Send',
    PendingReply: 'Pending Reply',
    Overdue: 'Overdue',
    Completed: 'Completed',
    Rejected: 'Rejected'
} as const;
export type GetReferralsByStatusStatusEnum = typeof GetReferralsByStatusStatusEnum[keyof typeof GetReferralsByStatusStatusEnum];
/**
 * @export
 */
export const MarkHealthRecordReadTypeEnum = {
    Appointment: 'Appointment',
    AppointmentNote: 'AppointmentNote',
    Immunization: 'Immunization',
    Prescription: 'Prescription',
    PatientDocument: 'PatientDocument'
} as const;
export type MarkHealthRecordReadTypeEnum = typeof MarkHealthRecordReadTypeEnum[keyof typeof MarkHealthRecordReadTypeEnum];
